// Salida a otra página (por ejemplo, el checkout de Wompi). Va en su propio
// módulo para poder simularla en las pruebas: jsdom no deja espiar
// window.location.assign.
export const irA = (url) => {
  window.location.assign(url);
};
